function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".clst-1{fill:#666;}.clst-2{fill:#000;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "paydayText");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  className: "clst-1",
  d: "M167.68,49.63v57.79H162V95.13a27,27,0,0,1-23.63,13.22c-16.15,0-29.37-12.16-29.37-29.83s13.22-29.6,29.37-29.6c9.35,0,18.83,4.33,23.63,13.34V49.63Zm-53,28.89c0,14.51,10.53,24.22,23.64,24.22,32.17,0,32.17-48.32,0-48.32C125.21,54.42,114.68,64,114.68,78.52Z"
}), React.createElement("path", {
  className: "clst-1",
  d: "M230.15,49.63l-35.21,81.89h-6.08l10.64-24.8L176.34,49.63h6.2L196,83.79l6.79,16.73,6.67-16.85,14.51-34Z"
}), React.createElement("path", {
  d: "M28.83,95.76,28.71,127l-8.93,0,.41-107L71,20.2c50.26.19,50,75.91-.3,75.72Zm.26-67.46-.23,59.36,41.83.16c38.52.15,38.75-59.21.23-59.35Z"
}), React.createElement("path", {
  className: "clst-2",
  d: "M19.75,48l.07-19.91L0,28l0-8.32,19.83.07L19.93,0l8.45,0L28.3,19.8l19.83.07,0,8.33-19.83-.08L28.19,48Z"
}), React.createElement("path", {
  d: "M254,140.77v16.32h-8.92V50.34h50.75c50.26,0,50.26,90.43,0,90.43Zm0-80.56V131.1h41.83c38.52,0,38.52-70.89,0-70.89Z"
}), React.createElement("path", {
  className: "clst-2",
  d: "M245.74,78.12V58.21H225.91V49.89h19.83V30.12h8.45V49.89H274v8.32H254.19V78.12Z"
}), React.createElement("path", {
  className: "clst-1",
  d: "M396,61.77v57.79h-5.73V107.28a27,27,0,0,1-23.63,13.22c-16.15,0-29.37-12.17-29.37-29.83s13.22-29.6,29.37-29.6c9.36,0,18.83,4.33,23.63,13.34V61.77Zm-53,28.9c0,14.5,10.52,24.21,23.63,24.21,32.17,0,32.17-48.31,0-48.31C353.57,66.57,343.05,76.16,343.05,90.67Z"
}), React.createElement("path", {
  className: "clst-1",
  d: "M458.52,61.77,423.3,143.66h-6.08l10.65-24.8L404.7,61.77h6.2l13.46,34.16,6.78,16.73,6.67-16.85,14.51-34Z"
})));

var SvgPaydayText = function SvgPaydayText(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 458.52 157.09",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPaydayText, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paydayText.f1382b93.svg";
export { ForwardRef as ReactComponent };